ACC.storefinderPopin = {

	_autoload: [
		["initPopin", $("#popinStoreFinder").length != 0 ],
		["bindStoreChangePopin", $("#popinStoreFinder .js-store-finder").length != 0 ],
		["bindSearchPopin", $("#popinStoreFinder .js-store-finder").length != 0],
		["loadAgencyPopin", $("#popinStoreFinder #postalCode").length != 0],
		["selectAgencyOnNonAgenceRegisterPage", $("body").hasClass('page-clientNonAgenceRegisterPage')],
		"selectAgencyOnPopin",
		"openStoreFinderPopinWithZipCode",
		"openStoreFinderPopin",
		"openStoreFinderPopinModal",
		"bindButtonsClickPopin",
		"loadDelivryZone"
	],

	storeData: "",
	storeId: "",
	coords: {},
	storeSearchData: {},
	currentAgencyPostalCode: "",
	popinStoreFinder: '#popinStoreFinder',
	posPhoneNumber: "",
	popinFromFooter: false,
	preventPopinStoreFinderSubmit: false,

	createListItemHtmlPopin: function (data,id){

		var item="";
		item+='<li class="list__entry">';
		item+='<input type="hidden" id="isActivated" value="'+data.activated+'">';
		item+='<input type="hidden" name="pointOfServiceName" id="pointOfServiceName" value="'+data.name+'"/>';
		item+='<input type="hidden" name="pointOfServiceDisplayName" id="pointOfServiceDisplayName" value="'+data.displayName+'"/>';
		item+='<input type="radio" name="popinStoreNamePost" value="'+data.name+'" id="popin-store-filder-entry-'+id+'" class="js-popin-store-finder-input" data-id="'+id+'" data-display-Name="'+data.displayName+'">';
		item+='<label for="popin-store-filder-entry-'+id+'" class="js-select-popin-store-label">';
		item+='<span class="entry__info">';
		item+='<span class="entry__name">'+data.displayName+'</span>';
		item+='<span class="entry__address">'+data.line1+' '+data.line2+'</span>';
		item+='<span class="entry__cp">'+data.postalCode+'</span>';
		item+='<span class="entry__city">'+data.town+'</span>';
		item+='</span>';
		item+='<span class="entry__distance">';
		item+='<span>'+data.formattedDistance+'</span>';
		item+='</span>';
		item+='<span class"scrollBar_container"></span>';
		item+='</label>';
		item+='</li>';

		$('#pointOfServiceName').val(data.name);
		$('#pointOfServiceDisplayName').val(data.displayName);
		$("#rememberAgency").trigger('click');
		return item;
	},

	refreshNavigationPopin: function (){
		var listitems = "";
		data = ACC.storefinderPopin.storeData

		if(data){
			for(i = 0;i < data["data"].length;i++){
				if(ACC.storefinderPopin.currentAgencyPostalCode != "" && data["data"][i].postalCode === ACC.storefinderPopin.currentAgencyPostalCode) {
					listitems += ACC.storefinderPopin.createListItemHtmlPopin(data["data"][i],i);
					break;
				} else {
					listitems += ACC.storefinderPopin.createListItemHtmlPopin(data["data"][i],i);
				}
			}

			$("#popinStoreFinder .js-store-finder-navigation-list").html(listitems);

		}

		ACC.storefinderPopin.showTotalResultText(ACC.storefinderPopin.storeData.total);
	},

	showTotalResultText: function(total) {
		$('#popinStoreFinder .store_result_count').removeClass('hidden');

		var one   = $("#popinStoreFinder .store_result_count .store_result_count_one"),
			all   = $("#popinStoreFinder .store_result_count .store_result_count_all");

		if(total == 1) {
			one.removeClass('hidden');
			one.find('.numder').html(total);
			all.addClass('hidden');
		} else {
			all.removeClass('hidden');
			all.find('.numder').html(total);
			one.addClass('hidden');
		}
	},

	bindStoreChangePopin:function()
	{
		$(document).on("click","#popinStoreFinder .js-select-popin-store-label",function(e){
			var posPhoneNumber = ACC.storefinderPopin.storeData['data'][$(this).parent().find('.js-popin-store-finder-input').data('id')]['phone'];
			if($(this).parent().find('#isActivated').val() == 'false') {
				$('#saveAgencyPopinForm').addClass('hidden');
				$('#popinStoreFinder .choose_agency').addClass('hidden');
				$('#popinStoreFinder .disabled-agency-msg').removeClass('hidden');
				$('#popinStoreFinder .disabled-agency-msg-phone').html(' ' + posPhoneNumber + '.');
			} else {
				$('#saveAgencyPopinForm').removeClass('hidden');
				$('#popinStoreFinder .choose_agency').removeClass('hidden');
				$('#popinStoreFinder .disabled-agency-msg').addClass('hidden');
				$('#popinStoreFinder .disabled-agency-msg-phone').html('');
				$("#popinStoreFinder .js-store-finder .choose_agency").removeAttr('disabled');
			}
		})
	},

	bindSearchPopin:function(){
		$(document).on("submit", ACC.storefinderPopin.popinStoreFinder, function(e){
			e.preventDefault();

			if (ACC.storefinderPopin.preventPopinStoreFinderSubmit) {
			    return false;
			}

			var q = $("#popinStoreFinder .js-store-finder-search-input").val(),
				lat = null,
				long = null,
				isoCode= $("#popinStoreFinder #codeCountry").val();

			if(navigator.geolocation && !$.isEmptyObject(ACC.storefinderPopin.coords)) {
				lat = ACC.storefinderPopin.coords.latitude;
				long = ACC.storefinderPopin.coords.longitude;
			}

			if(q.length > 0) {
				if(lat != null && long != null) {
					ACC.storefinderPopin.getInitStoreData(q, lat, long, isoCode);
				} else {
					ACC.storefinderPopin.getInitStoreData(q, null, null, isoCode);
				}
			} else if($("#currentPOS_postalCode").length != 0 && $("#currentPOS_postalCode").val() != "") {
				ACC.storefinderPopin.currentAgencyPostalCode = q = $("#currentPOS_postalCode").val();

				if(lat != null && long != null) {
					ACC.storefinderPopin.getInitStoreData(q, lat, long, isoCode);
				} else {
					ACC.storefinderPopin.getInitStoreData(q, null, null, isoCode);
				}
			} else {
				$(".js-store-finder").hide();
				$("#popinStoreFinder .emptySearchMessage").removeClass('hidden');
				$("#popinStoreFinder .js-store-finder-search-input").addClass('error');
				$("#popinStoreFinder .amds-select-option").addClass("error");
			}

			$(".modal-body, .store__finder--navigation-list").perfectScrollbar({
				useBothWheelAxes: false,
				suppressScrollX: true
			});

			setTimeout(function(){
				$(".modal-body,.store__finder--navigation-list").scrollTop(1);
			},300);

			return false;
		});

		$(".js-store-finder").hide();

		$(document).on("click",'#findStoresNearMe', function(e){
			e.preventDefault()
			ACC.storefinderPopin.getInitStoreData(null,ACC.storefinderPopin.coords.latitude,ACC.storefinderPopin.coords.longitude);
		})
	},

	getStoreData: function(page){
		ACC.storefinderPopin.storeSearchData.page = page;
		url= $("#popinStoreFinder .js-store-finder").data("url");
		$.ajax({
			url: url,
			data: ACC.storefinderPopin.storeSearchData,
			type: "get",
			success: function (response){
				try {
					ACC.storefinderPopin.storeData = $.parseJSON(response);
					$("#popinStoreFinder .js-store-finder").show();
					ACC.storefinderPopin.refreshNavigationPopin();
				} catch (e) {
					$("#popinStoreFinder .js-store-finder").hide();
					$("#popinStoreFinder .emptySearchMessage").removeClass('hidden');
					$("#popinStoreFinder .js-store-finder-search-input").addClass('error');
					$("#popinStoreFinder .amds-select-option").addClass("error");
				}
			}
		});
	},

	getInitStoreData: function(q,latitude,longitude,isoCode){
		codeVisible= $("#popinStoreFinder #codeVisible").val();
		$("#popinStoreFinder .emptySearchMessage").addClass('hidden');
		$("#popinStoreFinder .js-store-finder-search-input").removeClass('error');
		$("#popinStoreFinder .amds-select-option").removeClass("error");
		$("#popinStoreFinder #saveAgencyPopinForm .choose_agency").attr("disabled","true");
		data ={
			"q":"" ,
			"page":0,
			"show":"All"
		}
		if(codeVisible != null)
		{
			data.codeVisible = codeVisible;
		}
		if(q != null){
			data.q = q;
		}

		if(latitude != null){
			data.latitude = latitude;
		}

		if(longitude != null){
			data.longitude = longitude;
		}

		if(isoCode != null){
			data.isoCode = isoCode;
		}

		ACC.storefinderPopin.storeSearchData = data;
		ACC.storefinderPopin.getStoreData(0);
	},

	loadAgencyPopin: function() {
		$('#storeFinderForm').submit();
	},

	openStoreFinderPopinInHomePage: function() {
		if($.cookie("homePageVisited") === null && $('#hasPOSinSession').val() === 'false') {
			ACC.storefinderPopin.openStoreFinderPopinModal(true);
			$.cookie("homePageVisited", true);
		}
	},

	openStoreFinderPopinWithZipCode: function() {
		var zipcode = "", isoCode = "";

		$(document).on('keypress', '.js-sfpopin-zipcode-input', function(e){

			if (e.keyCode == 13 || e.which == 13) {
				zipcode = $(this).val();
				$('.js-sfpopin-zipcode-btn').click();
			}
		});

		$(document).on('click', '.js-sfpopin-zipcode-btn', function(){

			if($(this).closest('footer').length > 0) {
				ACC.storefinderPopin.popinFromFooter = true;
			} else {
				ACC.storefinderPopin.popinFromFooter = false;
				var _zipcode = $(this).parent().find('.js-sfpopin-zipcode-input').val();
				var _isoCode = $(this).parent().find('#codeCountry').val();

				if(zipcode == "" || zipcode != _zipcode) {
					zipcode = $(this).parent().find('.js-sfpopin-zipcode-input').val();
				}
				if(isoCode == "" || isoCode != _isoCode) {
					isoCode = $(this).parent().find('#codeCountry').val();
				}
			}

			ACC.storefinderPopin.openStoreFinderPopinModal(true);

			if($(this).closest('footer').length == 0) {
				/* add perfect scroll bar to modal */
				$(".modal-body, .store__finder--navigation-list").perfectScrollbar({
					useBothWheelAxes: false,
					suppressScrollX: true
				});

				setTimeout(function(){
					$('#popinStoreFinder li [data-codecountry="'+isoCode+'"]').trigger('click');
					$('#popinStoreFinder .js-store-finder-search-input').val(zipcode);
					$('#popinStoreFinder #storeFinderForm').submit();
				}, 100);
			}
		});
	},

	openStoreFinderPopin: function() {
		$(".btn_open_popin").on("click", function() {
			ACC.storefinderPopin.openStoreFinderPopinModal(true);
		});
	},

	openStoreFinderPopinModal: function(open) {
		if(open) {
			$(ACC.storefinderPopin.popinStoreFinder).modal({backdrop: 'static', keyboard: true});

			$("body").addClass("modal-store");
			/* Contentsquare */
			ACC.track.contentsquareAPVTracking("agency-choice" );
			/* Contentsquare */
		}
	},

	closeStoreFinderPopinModal: function() {
		$(ACC.storefinderPopin.popinStoreFinder).modal("toggle");

		if($('body').hasClass('page-clientNonAgenceRegisterPage') && !ACC.storefinderPopin.popinFromFooter) {
			ACC.register.triggerSubmit = true;
			$(ACC.register.validateFormID).submit();
		}
	},

	selectAgencyOnNonAgenceRegisterPage: function() {
		$(document).on('click', ACC.storefinderPopin.popinStoreFinder + ' .choose_agency', function() {
			if($('input[name=popinStoreNamePost]').length > 0) {
				$('.attachmentAgency').val($('input[name=popinStoreNamePost]:checked').val());
			}
			ACC.storefinderPopin.closeStoreFinderPopinModal();
		})
	},

	selectAgencyOnPopin: function() {
		$(document).on('submit', '#saveAgencyPopinForm', function(e) {
			e.preventDefault();

			ACC.storefinderPopin.preventPopinStoreFinderSubmit = true;

			if($("body").hasClass('page-clientNonAgenceRegisterPage') && !ACC.storefinderPopin.popinFromFooter) {
				return false;
			}

			var action = $(this).attr('action');
			var pointOfServiceName = $('input[name=popinStoreNamePost]:checked').val();
			var rememberAgency = !$('#rememberAgency').prop('checked');
			if($('input[name=popinStoreNamePost]').length > 0 && pointOfServiceName !== undefined && rememberAgency !== undefined) {
				$.ajax({
					url: action,
					type: "POST",
					data: {
						pointOfServiceName: pointOfServiceName,
						rememberAgency: rememberAgency
					},
					dataType: "json",
					success: function(){
						location.reload();
					},
					error: function(xhr, error){
						ACC.storefinderPopin.preventPopinStoreFinderSubmit = false;
					}
				});
			} else {
				console.error("Error sending request due to pointOfServiceName : "+pointOfServiceName+" or rememberAgency : "+rememberAgency);
			}
		});
	},

	bindButtonsClickPopin: function () {
		$("#popinStoreFinder .btn_close").on("click", function() {
			ACC.storefinderPopin.closeStoreFinderPopinModal();
			ACC.storefinderPopin.popinFromFooter = false;
		});
	},

	initPopin:function(){
		$('body').addClass('noGeolocation');

		if(navigator.geolocation){
			navigator.geolocation.getCurrentPosition(
				function (position){
					ACC.storefinderPopin.coords = position.coords;
					$('body').removeClass('noGeolocation');
				},
				function (error)
				{
					console.log("An error occurred... The error code and message are: " + error.code + "/" + error.message);
				}
			);
		}

		$(ACC.storefinderPopin.popinStoreFinder).on("shown.bs.modal", function() {
			$(this).find('#popinStoreFinder .js-store-finder-search-input').focus();
		});

		$(ACC.storefinderPopin.popinStoreFinder).on("hidden.bs.modal", function() {
			$("body").removeClass("modal-store");
		});

		if($.cookie("noPOSAnywherePopinOpened") === null && $('#noPOSAnywhere').val() === 'true' && $('body').hasClass('page-account')) {
			ACC.storefinderPopin.openStoreFinderPopinModal(true);
			$.cookie("noPOSAnywherePopinOpened", true, {path: '/'});
		}
	},
	loadDelivryZone: function() {
		if ($("#regions_div").length > 0) {
			var coveredAreas=$("#regions_div").data("covered");
			var coveredInAreas = [];
			var coveredInExp=$("#regions_div").data("coveredin");

			if(coveredInExp != "")
			{
				coveredInAreas = coveredInExp.split(":");
			}

			var coveredInText=$("#regions_div").data("textcoveredin");
			var coveredText=$("#regions_div").data("textcovered");
			var areas = [ {
				"id": "AT",
				"color": "#ffffff"
			}, {
				"id": "IE",
				"color": "#ffffff"
			}, {
				"id": "DK",
				"color": "#ffffff"
			}, {
				"id": "GB",
				"color": "#ffffff"
			}, {
				"id": "IT",
				"color": "#ffffff"
			}, {
				"id": "FR",
				"color": "#ffffff",
			}, {
				"id": "ES",
				"color": "#ffffff"
			}, {
				"id": "GR",
				"color": "#ffffff"
			}, {
				"id": "DE",
				"color": "#ffffff"
			}, {
				"id": "BE",
				"color": "#ffffff",
			}, {
				"id": "LU",
				"color": "#ffffff"
			}, {
				"id": "NL",
				"color": "#ffffff"
			}, {
				"id": "PT",
				"color": "#ffffff"
			}, {
				"id": "LT",
				"color": "#ffffff"
			}, {
				"id": "LV",
				"color": "#ffffff"
			}, {
				"id": "CZ",
				"color": "#ffffff"
			}, {
				"id": "SK",
				"color": "#ffffff"
			}, {
				"id": "SI",
				"color": "#ffffff"
			}, {
				"id": "EE",
				"color": "#ffffff"
			}, {
				"id": "HU",
				"color": "#ffffff"
			}, {
				"id": "CY",
				"color": "#ffffff"
			}, {
				"id": "MT",
				"color": "#ffffff"
			}, {
				"id": "PL",
				"color": "#ffffff"
			}, {
				"id": "RO",
				"color": "#ffffff"
			}, {
				"id": "BG",
				"color": "#ffffff"
			}, {
				"id": "HR",
				"color": "#ffffff"
			},{
				"id": "ES-ISLANDS",
				"color": "#ffffff"
			}
			];

			for (index in areas) {
				if(coveredAreas.indexOf(areas[index].id) >= 0 )
				{
					areas[index].color="#ff3700";
					areas[index].url="store-finder?country="+areas[index].id;
				}
				else if (coveredInAreas.length > 1 && coveredInAreas[1].indexOf(areas[index].id) >= 0) {
					areas[index].color="#ffcec1";
				}

			}

			var chartData = [
				{
					"title": coveredText,
					"color": "#ff3700"
				}];

			if(coveredInAreas.length > 0)
			{
				chartData.push(
					{
						"title": coveredInText+coveredInAreas[0],
						"color": "#ffcec1"
					}
				);
			}

			var map = AmCharts.makeChart( "regions_div", {
				"type": "map",
				"dataProvider": {
					"map": "worldHigh",
					"zoomLevel": 7,
					"zoomLongitude": 5,
					"zoomLatitude": 47,
					"areas": areas
				},
				"areasSettings": {
					"unlistedAreasAlpha": 0,
					"outlineColor": "#B0B1B5",
					"rollOverOutlineColor": "#B0B1B5",
				},
				"legend": {
					"width": "100%",
					"marginRight": 27,
					"marginLeft": 27,
					"equalWidths": false,
					"backgroundAlpha": 1,
					"backgroundColor": "#FFFFFF",
					"borderColor": "#ffffff",
					"borderAlpha": 1,
					"top": 575,
					"left": 0,
					"horizontalGap": 10,
					"data": chartData
				}

			} );
		}
	}
};
